import { bool } from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import useStyle from "../LabelsDialog.style";
import classnames from "classnames";

export const TitleRow = ({ noRemoval=false }) => {
  const {t} = useTranslation();
  const classes = useStyle(noRemoval);
  
  return (
    <Grid
      item
      container
      wrap="nowrap"
      alignItems="center"
      justifyContent="space-between"
    >
      <Grid item container className={classes.labelCell}>
        <span>{t("common.label")}</span>
      </Grid>
      <Grid item container>
        <span>{t("common.title")}</span>
      </Grid>
      <Grid
        item container
        className={classnames(classes.colorCell, noRemoval && classes.noRemoval)}
      >
        <span>{ t("common.color") }</span>
      </Grid>
    </Grid>
  );
}

TitleRow.propTypes = {
  noRemoval: bool
}